"use strict";
'use client';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.App = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _index = require("../../styles/index.js");
var _index2 = require("../KeyboardDetectionProvider/index.js");
var _index3 = require("../SkipLink/index.js");
var _Banner = require("./Banner.js");
var _Container = require("./Container.js");
var _Content = require("./Content.js");
var _Main = require("./Main.js");
var _Sidebar = require("./Sidebar.js");
var _logging = require("../../logging.js");
var _excluded = ["className", "navigation", "contentMaxWidth", "contentId", "skipLinkLabel", "sidebarWidth", "banner", "persistentBanner", "persistentBannerLabel", "statusBanner", "statusBannerLabel", "content", "footer", "useKeyboardDetection", "colorSet", "semanticBackgroundColor"];
/**
 * The App component is a content wrapper that can use a combination of components to build a basic responsive layout structure.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-app--docs) |
 * [Encore site](https://encore.spotify.net/components/app-layout) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/App)
 */
var App = exports.App = /*#__PURE__*/_react["default"].forwardRef(function App(_ref, ref) {
  var className = _ref.className,
    navigation = _ref.navigation,
    contentMaxWidth = _ref.contentMaxWidth,
    _ref$contentId = _ref.contentId,
    contentId = _ref$contentId === void 0 ? 'encore-web-main-content' : _ref$contentId,
    skipLinkLabel = _ref.skipLinkLabel,
    sidebarWidth = _ref.sidebarWidth,
    banner = _ref.banner,
    persistentBanner = _ref.persistentBanner,
    _ref$persistentBanner = _ref.persistentBannerLabel,
    persistentBannerLabel = _ref$persistentBanner === void 0 ? 'Banner' : _ref$persistentBanner,
    statusBanner = _ref.statusBanner,
    _ref$statusBannerLabe = _ref.statusBannerLabel,
    statusBannerLabel = _ref$statusBannerLabe === void 0 ? 'Status' : _ref$statusBannerLabe,
    content = _ref.content,
    footer = _ref.footer,
    _ref$useKeyboardDetec = _ref.useKeyboardDetection,
    useKeyboardDetection = _ref$useKeyboardDetec === void 0 ? true : _ref$useKeyboardDetec,
    _ref$colorSet = _ref.colorSet,
    colorSet = _ref$colorSet === void 0 ? 'base' : _ref$colorSet,
    _ref$semanticBackgrou = _ref.semanticBackgroundColor,
    semanticBackgroundColor = _ref$semanticBackgrou === void 0 ? 'backgroundBase' : _ref$semanticBackgrou,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  if (banner) {
    (0, _logging.deprecatedPropWarning)('banner', 'App', 'Please use statusBanner for status type banners and use persistentBanner for persistent app wide banners.');
  }
  var Wrapper = useKeyboardDetection ? _index2.KeyboardDetectionProvider : _react["default"].Fragment;
  return /*#__PURE__*/_react["default"].createElement(Wrapper, null, /*#__PURE__*/_react["default"].createElement(_Container.Container, Object.assign({
    $semanticBackgroundColor: semanticBackgroundColor,
    className: (0, _index.addColorSet)(colorSet, className),
    ref: ref
  }, props), /*#__PURE__*/_react["default"].createElement(_index3.SkipLink, {
    href: "#".concat(contentId),
    colorSet: "invertedLight"
  }, skipLinkLabel), /*#__PURE__*/_react["default"].createElement(_Sidebar.Sidebar, {
    $sidebarWidth: sidebarWidth
  }, navigation), /*#__PURE__*/_react["default"].createElement(_Content.Content, {
    $contentMaxWidth: contentMaxWidth,
    $sidebarWidth: sidebarWidth
  }, /*#__PURE__*/_react["default"].createElement(_Banner.BannerHeader, null, /*#__PURE__*/_react["default"].createElement(_Banner.Banner, {
    "aria-label": statusBannerLabel,
    "aria-live": "polite"
  }, statusBanner), /*#__PURE__*/_react["default"].createElement(_Banner.Banner, {
    "aria-label": persistentBannerLabel
  }, persistentBanner || banner)), /*#__PURE__*/_react["default"].createElement(_Main.Main, {
    id: contentId,
    tabIndex: -1
  }, content), /*#__PURE__*/_react["default"].createElement("div", null, footer))));
});